import { twMerge } from "tailwind-merge";
import { ReactNode } from "react";

import { TDirection } from "@treezor/design-system";

export type TSummaryInformationItemProps = {
  label: string;
  value: ReactNode;
  direction?: TDirection;
  className?: string;
};

export function SummaryInformationContent({
  label,
  value,
  direction = "row",
  className,
}: TSummaryInformationItemProps) {
  return (
    <div
      className={twMerge(
        "flex",
        direction === "row" ? "gap-4" : "flex-col gap-1",
        className,
      )}
    >
      <p className="typo-body-regular-paragraph text-tertiary font-bold">
        {label}
      </p>
      <p className="typo-body-regular-paragraph text-secondary font-bold whitespace-pre-line">
        {value}
      </p>
    </div>
  );
}
